/**
 * Application Shell
 *
 * Accepts /test/* as a URL alias for backwards compatibility.
 */

import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { normalizeRoute, Topbar } from '@/components/app';

import { EditorPage } from './EditorPage';
import { FavoritesPage } from './FavoritesPage';
import { PipelinesPage } from './PipelinesPage';
import { SettingsPage } from './SettingsPage';
import { ToolsPage } from './ToolsPage';

export const AppShell: React.FC = () => {
  const [pathname, setPathname] = useState(() => window.location.pathname);

  useEffect(() => {
    const onPopState = () => setPathname(window.location.pathname);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const route = useMemo(() => normalizeRoute(pathname), [pathname]);

  const navigate = useCallback((to: string) => {
    if (window.location.pathname === to) return;
    window.history.pushState({}, '', to);
    setPathname(to);
  }, []);

  return (
    <div className="h-screen flex flex-col bg-background text-foreground">
      <Topbar route={route} onNavigate={navigate} />

      <div className="flex-1 overflow-hidden flex">
        <div className="flex-1 overflow-auto">
          {route === 'tools' && <ToolsPage onNavigate={navigate} />}
          {route === 'editor' && <EditorPage />}
          {route === 'settings' && <SettingsPage />}
          {route === 'pipelines' && <PipelinesPage onNavigate={navigate} />}
          {route === 'favorites' && <FavoritesPage onNavigate={navigate} />}
        </div>
      </div>
    </div>
  );
};
